import React, { useEffect, useState } from 'react';
import { JSON_ONE } from "./JSON_DATA_Request";
import { JSON_ONE1} from "./JSON_DATA_Response";
import { JSON_ONE11} from "./JSON_DATA_Requestflowone";
import { JSON_ONE21} from "./JSON_DATA_Responseflowone";
import { JSON_ONE31} from "./JSON_DATA_Requestflowtwo";
import { JSON_ONE41} from "./JSON_DATA_Responseflowtwo";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import Accordion from './Accordion';
import ResponseJSON from './ResponseJSON';
import RequestJSON from './RequestJSON';
function PaymentIntegration() {
const [TabCheck11, SetTabCheck11] = useState(false)
const [TabCheck21, SetTabCheck21] = useState(false)
const [TabCheck1, SetTabCheck1] = useState(false)
const [TabCheck2, SetTabCheck2] = useState(false)
const [TabCheck, SetTabCheck] = useState(false)
const onClickCangeTab = () => {
SetTabCheck(!TabCheck);
}
const onClickCangeTab1 = () => {
SetTabCheck1(!TabCheck1);
}
const onClickCangeTab11 = () => {
SetTabCheck11(!TabCheck11);
}
const onClickCangeTab21 = () => {
SetTabCheck21(!TabCheck21);
}
const onClickCangeTab2 = () => {
SetTabCheck2(!TabCheck2);
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_layout1">
               <h1>Payment Integration</h1>
               <hr />
            </section>
         </div>
         <div class="col-md-4 extreme-rt-div">
         </div>
      </div>
      <div className='row'>
         <div className='col-md-8'>
            <h2 class="mt-60" id="aggregator-hosted-pg-sec">Aggregator Hosted (Non-Seamless)</h2>
            <p className='mt-30'>Avoid struggling to develop and manage your checkout page. Use the customized payment page provided by Safexpay which enables you to collect payment from the customer. Safexpay payment page is fully customized enabling you to match the look and feel of your website to Font and Colors. Processing orders using Safexpay payment page.
            </p>
            <img class="img-fluid" src="assets/images/pg-images/aggregator.PNG"></img>
            <h5>Process flow:</h5>
            <ol>
               <li>Customer selects product/service on your website and proceeds to make payment.</li>
               <li>The Customer is redirected to the Safexpay payment page where payment information is entered by the customer.</li>
               <li>On submission of the transaction information, Safexpay initiates the authorization process by connecting to the relevant bank/processing organization.</li>
               <li>On receiving the authorization status from the bank, Safexpay sends the response back to your website with the transaction status.</li>
            </ol>
            <div class="rec-box">
               <h6>Recommendation:</h6>
               <p>Make sure that you are sending the request in HTTP Form post method. The transaction request is not compatible to run on Postman Platform. Transactions are only permitted through registered merchant domains. If “localhost” or local IP is not permitted, you will get an “Invalid Referral URL.” error in such a case. Transaction requests must be in the below manner when it triggers our Payment Gateway URL. Merchant must send the following parameters to the Safexpay PG which is mandatory, but values might be blank in case of optional or not required.</p>
            </div>
            <h5 class="mt-30">Sample Request:-</h5>
            <div class="form-data">
            <text class="formData" readonly="">&lt;!DOCTYPE html&gt;&lt;/p&gt;
&lt;html&gt; {'\n'}
&lt;body&gt;{'\n'}
  &lt;form name="form1" action="https://www.avantgardepayments.com/agcore/payment"
   method="post"&gt;{'\n'}
  &lt;input type="text" name="me_id"         value="202104210302"&gt;{'\n'}
  &lt;input type="text" name="txn_details"   value="TcS05nvFOPBFAdKMFKhlq21tO"&gt;{'\n'}
  &lt;input type="text" name="pg_details"    value="eaQBGHBgVQx3o3f7m7wJMw=="&gt;{'\n'}
  &lt;input type="text" name="card_details"  value="q2ps3NoEIE7WaVSrR8rr3w=="&gt;{'\n'}
  &lt;input type="text" name="cust_details"  value="jOfnFYi3d59MVY8HsIUKJBn4"&gt;{'\n'}
  &lt;input type="text" name="bill_details"  value="q2ps3NoEIE7WaVSrR8rr3w=="&gt;{'\n'}
  &lt;input type="text" name="ship_details"  value="mtPiVPGwMjJoIW734M/zdg=="&gt;{'\n'}
  &lt;input type="text" name="item_details"  value="ssyLWjUN2tYkiOOVqCpCCA=="&gt;{'\n'}
  &lt;input type="text" name="other_details" value="q2ps3NoEIE7WaVSrR8rr3w=="&gt;{'\n'}
  &lt;input type="text" name="upi_details"   value="q2ps3NoEIE7WaVSrR8rr3w=="&gt;{'\n'}
  &lt;input type="submit" name="submit" value="Pay Now"&gt;{'\n'}
  &lt;/form&gt;{'\n'}
&lt;/body&gt;{'\n'}
&lt;/html&gt;{'\n'}
</text>
            </div>


            <div class="form-data">
            <text class="formData" readonly="">
"txnDetails"{'\u003A'} 


{'\u007B'}{'\n'}
"txnDetails": {'\u007B'}{'\n'}
  "orderNo": 2599,{'\n'}
  "amount": "1",{'\n'}
  "countryCode": "IND",{'\n'}
  "currencyCode": "INR",{'\n'}
  "txnType": "SALE",{'\n'}
  "channel": "WEB",{'\n'}
  "userId": "custemail@hotmail.com"{'\n'}
  {'\u007D'}{'\n'}
  {'\u007D'}

</text>


<pre><code><span class="token operator">&lt;</span>script<span class="token operator">&gt;</span>
  let jsCheckoutOptions <span class="token operator">=</span> <span class="token punctuation">{'\u007B'}</span>merchantId<span class="token punctuation">:</span> <span class="token string">"999990300010"</span> <span class="token operator">&lt;</span><span class="token operator">&lt;</span><span class="token operator">&lt;</span> Merchant ID <span class="token punctuation">{'\u007D'}</span>
  let spObj <span class="token operator">=</span> <span class="token keyword">new</span> <span class="token class-name">JsCheckout</span><span class="token punctuation">(</span><span class="token punctuation">)</span><span class="token punctuation">;</span> <span class="token comment">// Creating object of JS Checkout Library.</span>
  spObj<span class="token punctuation">.</span><span class="token function">Init</span><span class="token punctuation">(</span>jsCheckoutOptions<span class="token punctuation">)</span><span class="token punctuation">;</span> <span class="token comment">// Initializing the required options.</span>
  Buy <span class="token operator">=</span> <span class="token keyword">function</span><span class="token punctuation">(</span><span class="token punctuation">)</span> <span class="token punctuation">{'\u007B'}</span>spObj<span class="token punctuation">.</span><span class="token function">Pay</span><span class="token punctuation">{'\u0028'}</span><span class="token string">'encryptedData'</span><span class="token punctuation">,</span><span class="token string">'hash'</span><span class="token punctuation">,</span><span class="token string">'orderDetails'</span><span class="token punctuation">,</span> CallbackForResponse<span class="token punctuation">{'\u0029'}</span><span class="token punctuation">;</span> <span class="token punctuation">{'\u007D'}</span>
  <span class="token keyword">function</span> <span class="token function">CallbackForResponse</span><span class="token punctuation">(</span>response<span class="token punctuation">)</span> <span class="token punctuation">{'\u007B'}</span> console<span class="token punctuation">.</span><span class="token function">log</span><span class="token punctuation">{'\u0028'}</span><span class="token string">"ResponseInCallback:::"</span><span class="token punctuation">,</span> response<span class="token punctuation">{'\u0029'}</span><span class="token punctuation">;</span> <span class="token punctuation">{'\u007D'}</span>
<span class="token operator">&lt;</span><span class="token operator">/</span>script<span class="token operator">&gt;</span></code></pre>






<pre>
   
INSERT INTO `vm_extensions` (`extension_id`, `name`, `type`, `element`, `folder`, `client_id`, `enabled`, `access`, `protected`, `manifest_cache`, `params`, `custom_data`, `system_data`, `checked_out`, `checked_out_time`, `ordering`, `state`) VALUES
      (NULL, 'AvantGarde Payments', 'plugin', 'avantgarde', 'vmpayment', 0, 1, 1, 0, '{'\u007B'}"legacy":false,"name":"AvantGarde Payments","type":"plugin","creationDate":"June 08 2016","author":"Nagaraju Bandi","copyright":"Copyright (C) 2016-2017 AvantGarde Team. All rights reserved.","authorEmail":"","authorUrl": "http:\\/\\/www.avantgardepayments.com","version":"1.0","description": "AvantGarde Payments plugin","group":""{'\u007D'}', '', '', '', 0, '0000-00-00 00:00:00', 1, 0);
    
</pre>


            </div>
            <form name="form1" method="post" action="https://pguat.safexpay.com/agcore/instantPay" target="_blank">
  <input type="hidden" readonly="" name="meId" value="201712050001"/>
  <input type="hidden" readonly="" name="amount" value=""/>
  <input type="hidden" readonly="" name="txnType" value="instantPay"/>
  <input type="hidden" readonly="" name="token" value="07wJ9japKHDt2kLhzP8nsNZMlZAmvSdMmh0a7WHbo*gk3WPxcoS3*XOZ4xVqIA8k"/>
  <input type="hidden" readonly="" name="successUrl" value=""/>
  <input type="hidden" readonly="" name="failureUrl" value=""/>
  <input type="hidden" readonly="" name="custTxnAmount" value="2"/>
  <input type="hidden" readonly="" name="countryCode" value="IND"/>
  <input type="hidden" readonly="" name="currencyCode" value="INR"/>
  <input type="hidden" readonly="" name="custName" value="test test"/>
  <input type="hidden" readonly="" name="emailId" value="u@u.com"/>
  <input type="hidden" readonly="" name="mobileNo" value="8888888888"/>
  <input type="hidden" readonly="" name="billAddress" value="test bill 1"/>
  <input type="hidden" readonly="" name="billCity" value="mumbai"/>
  <input type="hidden" readonly="" name="billState" value="Maharashtra"/>
  <input type="hidden" readonly="" name="billCountry" value=""/>
  <input type="hidden" readonly="" name="billZip" value=""/>
  <input type="hidden" readonly="" name="shipAddress" value=""/>
  <input type="hidden" readonly="" name="shipCity" value=""/>
  <input type="hidden" readonly="" name="shipState" value=""/>
  <input type="hidden" readonly="" name="shipCountry" value=""/>
  <input type="hidden" readonly="" name="shipZip" value=""/>

  <input class="btn btn-success mt-1 mb-1" name="Submit" type="submit" value="Try Checkout"/>
</form>
            <h5 class="mt-30">Decrypted Request:-</h5>
            <div class="form-data">
              <text>
              me_id: 202104210302{'\n'}
txn_details: Paygate|202104210302|96692adf|1600|IND|INR|SALE|<a href="http://localhost/safexpay/Response.php%7Chttp://localhost/safexpay/Response.php%7CWEB">http://localhost/safexpay/Response.php|http://localhost/safexpay/Response.php|WEB</a>{'\n'}
pg_details:|NB||{'\n'}
cust_details: Tommy|tommy@gmail.com|9999555666||Y{'\n'}
bill_details: Flat No.144, Gurukripa Apartments|Sangjo|Maharashtra|India|400013{'\n'}
ship_details: ||||||{'\n'}
item_details: ||{'\n'}
card_details: ||||{'\n'}
other_details: ||||{'\n'}
upi_details:{'\n'}

              </text>
            </div>
            <h5 class="mt-30">Encrypted Response: -</h5>
            <div className='form-box'>
               <div class="form-data">
                  txn_response: 9rDkZ+Z6yw7LqxZhDhJOa12+J/pO/A2vYt0WqViUNo9RdijYik8FTx+J7fcDExAJ9+JWc29Z+<br></br>
                  pg_details: VYMSdSPAou3KlcdmnNQMcUAp85X4cEO0V48L/cmXWgQ=<br></br>
                  fraud_details: ohteK/+vxZqmlXNSdlggZg==<br></br>
                  other_details: RpoxJcbt+QsFnWAKjf4LQw==    <br></br>
               </div>
            </div>
            <h5 class="mt-30">Decrypted Response: -</h5>
            <div className='form-box'>
               <div class="form-data">
                  txn_response:paygate|202104210302|317758778|1.00|IND|INR|2021-10-16|14:42:56.0|1031311634228840037|PG_1031311634228840037|Successful|0|Successful<br></br>
                  pg_details:63|Test Bank|NB|<br></br>
                  fraud_details:|NA|<br></br>
                  other_details:||||<br></br>
               </div>
            </div>
            <h6 class="mt-30"><u>AUTHORIZATIONS:</u></h6>
            <h6 class="mt-10"><span>REQUEST BODY SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/x-www-form-urlencode Not "json"</span></h6>
            <hr class="hr-col" />
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Merchant ID issued to you by Safexpay</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_details"><span class="sc-iemWCZ fhDkLh"></span><span>txn_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Parameter containing Transactions details viz.. order no, Amount, callback url etc..</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_details"><span class="sc-iemWCZ fhDkLh"></span><span>pg_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains bank identifier for on-going transaction.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_details"><span class="sc-iemWCZ fhDkLh"></span><span>cust_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains Customer information required by Acquiring/issuing bank.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_details"><span class="sc-iemWCZ fhDkLh"></span><span>bill_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Billing information of customer transacting.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ship_details"><span class="sc-iemWCZ fhDkLh"></span><span>ship_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Shipping information of customer transacting.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="item_details"><span class="sc-iemWCZ fhDkLh"></span><span>item_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Product details for the on-going transaction.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="card_details"><span class="sc-iemWCZ fhDkLh"></span><span>card_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains Card No, Expiry year, CVV, Card Holder Name.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="other_details"><span class="sc-iemWCZ fhDkLh"></span><span>other_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Additional field to be utilized by merchant for order details.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr class="last undefined">
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="upi_details"><span class="sc-iemWCZ fhDkLh"></span><span>upi_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains VPA(Virtual Payment Address) of end customer.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
            <h5 className="mt-20">Responses</h5>
            <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
               <div class="card">
                  <div class="card-header" id="heading1" style={{ backgroundColor: "#eff6f0"}}>
                  <h5 class="mb-0">
                     <div onClick={onClickCangeTab1}>
                        <span className="col-dark-green" style={{ color: "rgb(29, 129, 39)"}}>
                        <b>200</b> Encrypted Response Format{TabCheck1 ?
                        <FaAngleUp />
                        :
                        <FaAngleDown />
                        }
                        </span>
                     </div>
                  </h5>
               </div>
               {
               TabCheck1 &&
               <div>
                  <h6 class="mt-30">
                     <span>REQUEST BODY SCHEMA:  </span>
                     <span className='col-blk'> application/x-www-form-urlencode Not "json"</span>
                  </h6>
                  <hr class="hr-col">
                  </hr>
                  <table class="sc-hHEiqL iZJLLY">
                     <tbody>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_response"><span class="sc-iemWCZ fhDkLh"></span><span>txn_response</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Contains the status of the ongoing transaction with details.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_details"><span class="sc-iemWCZ fhDkLh"></span><span>pg_details</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Contains Acquirer and Issuer bank details</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr>
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_details"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_details</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Contains transaction risk details.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                        <tr class="last undefined">
                           <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="other_details"><span class="sc-iemWCZ fhDkLh"></span><span>other_details</span></td>
                           <td class="sc-bkbkJK gmOLLi">
                              <div>
                                 <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                 <div>
                                    <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                       <p>Additional parameters for merchant use.</p>
                                    </div>
                                 </div>
                              </div>
                           </td>
                        </tr>
                     </tbody>
                  </table>
               </div>
               }
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span><b>400</b> Bad request</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span><b>401</b> Unauthorized</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span><b>403</b> forbidden</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span><b>404</b> Not found</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span><b>500</b> server_error</span> </h5>
               </div>
            </div>
            <div class="card">
               <div class="card-header">
                  <h5 class="mb-0"> <span><b>503</b> service_unavailable</span> </h5>
               </div>
            </div>
            <div class="card mb-60">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div onClick={onClickCangeTab2}>
                        <span>
                           <b>default</b> Succesfull transaction {TabCheck2 ?
                           <FaAngleUp />
                           :
                           <FaAngleDown />
                           }
                        </span>
                     </div>
                  </h5>
               </div>
               {
               TabCheck2 &&
               <Accordion/>
               }
            </div>
         </div>
      </div>
      <div className='col-md-4 extreme-rt-div'>
         <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
            <div class="card">
               <div class="card-header" id="heading1">
                  <h5 class="mb-0">
                     <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab}>
                     <button> POST </button> /aggregatorHosted  {TabCheck ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
               </div>
               </h5>
            </div>
            {
            TabCheck &&
            <div>
               <br />
               <div class="card-body">
                  <p class="mb-0">Production server (uses live data)</p>
                  <div class="api-div-bor">
                     <span>https://www.avantgardepayments.com/agcore</span><span
                        class="col-org">/aggregatorHosted</span>
                  </div>
                  <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
                  <div class="api-div-bor">
                     <span>https://pguat.safexpay.com/agcore</span><span
                        class="col-org">/aggregatorHosted</span>
                  </div>
               </div>
            </div>
            }
         </div>
      </div>
      <RequestJSON/>
      <ResponseJSON/>
   </div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">

   <div class="col-md-8">
      
      <h2 class="mt-60" id="merchant-hosted-pg-sec">Merchant Hosted (Seamless)</h2>
      <p>
         The Safexpay payment integration supports a seamless payment experience on your platform while protecting your application from payment frauds and complexity related to various regulations. You can develop and manage your checkout page. You can configure Cards, Net-banking, Wallets, UPI, etc pay modes on your checkout page and send the customer’s payment request to the bank’s server directly via SafexPay integration.<br />
         As per RBI guidelines, and PCI/DSS, only the companies who have PCI/DSS compliance can collect/process the card details on their server. Due to this, if you are a PCI/DSS compliant company, then only you can store/process/collect the card details on your platform.
      </p>
      <img class="img-fluid" src="assets/images/pg-images/merchant-hosted.PNG"></img>
      <h5>Process flow:</h5>
      <ol>
         <li>Merchant can design the billing page on their website’s checkout page and capture the Card details or Net banking details etc. of the customer.</li>
         <li>Customer selects the respective payment options like Cards/NB/UPI etc. on Merchant’s Checkout page</li>
         <li>On submission of the payment information, the Merchant initiates a server-to-server call to Safexpay to fetch the request payload for the payment option selected by the user.</li>
         <li>The request payload received from Safexpay will be used to connect directly to the bank’s authentication/3D secure page, via Safexpay.</li>
         <li>Safexpay will receive the authorization status from the bank and in turn post the transaction status back to the merchant’s website.</li>
         <li>Value in each section will be encrypted value generated in the following way. Only me_id (Merchant ID) will be in plain text.</li>
         <li>Each attribute in every section is combined separated with pipe (|).</li>
      </ol>
      <div class="rec-box">
         <h6>Recommendation:</h6>
         <p>Make sure that you are sending the request in HTTP Form post method. The transaction request is not compatible to run on Postman Platform. Transactions are only permitted through registered merchant domains. If “localhost” or local IP is not permitted, you will get an “Invalid Referral URL.” error in such a case. Transaction requests must be in the below manner when it triggers our Payment Gateway URL. Merchant must send the following parameters to the Safexpay PG which is mandatory, but values might be blank in case of optional or not required.</p>
      </div>
      <h5 class="mt-30">Sample Request:-</h5>
      <div class="form-data">
      </div>
      <form name="form1" method="post" action="https://pguat.safexpay.com/agcore/instantPay" target="_blank">
  <input type="hidden" readonly="" name="meId" value="201712050001"/>
  <input type="hidden" readonly="" name="amount" value=""/>
  <input type="hidden" readonly="" name="txnType" value="instantPay"/>
  <input type="hidden" readonly="" name="token" value="07wJ9japKHDt2kLhzP8nsNZMlZAmvSdMmh0a7WHbo*gk3WPxcoS3*XOZ4xVqIA8k"/>
  <input type="hidden" readonly="" name="successUrl" value=""/>
  <input type="hidden" readonly="" name="failureUrl" value=""/>
  <input type="hidden" readonly="" name="custTxnAmount" value="2"/>
  <input type="hidden" readonly="" name="countryCode" value="IND"/>
  <input type="hidden" readonly="" name="currencyCode" value="INR"/>
  <input type="hidden" readonly="" name="custName" value="test test"/>
  <input type="hidden" readonly="" name="emailId" value="u@u.com"/>
  <input type="hidden" readonly="" name="mobileNo" value="8888888888"/>
  <input type="hidden" readonly="" name="billAddress" value="test bill 1"/>
  <input type="hidden" readonly="" name="billCity" value="mumbai"/>
  <input type="hidden" readonly="" name="billState" value="Maharashtra"/>
  <input type="hidden" readonly="" name="billCountry" value=""/>
  <input type="hidden" readonly="" name="billZip" value=""/>
  <input type="hidden" readonly="" name="shipAddress" value=""/>
  <input type="hidden" readonly="" name="shipCity" value=""/>
  <input type="hidden" readonly="" name="shipState" value=""/>
  <input type="hidden" readonly="" name="shipCountry" value=""/>
  <input type="hidden" readonly="" name="shipZip" value=""/>

  <input class="btn btn-success mt-1 mb-1" name="Submit" type="submit" value="Try Checkout"/>
</form>
      <h5 class="mt-30">Decrypted Request:-</h5>
      <div class="form-data">
         <p>test</p>
      </div>
      <h5 class="mt-30">Encrypted Response: -</h5>
      <div class="form-box">
         <div class="form-data">
            txn_response: 9rDkZ+Z6yw7LqxZhDhJOa12+J/pO/A2vYt0WqViUNo9RdijYik8FTx+J7fcDExAJ9+JWc29Z+<br></br>
            pg_details: VYMSdSPAou3KlcdmnNQMcUAp85X4cEO0V48L/cmXWgQ=<br></br>
            fraud_details: ohteK/+vxZqmlXNSdlggZg==<br></br>
            other_details: RpoxJcbt+QsFnWAKjf4LQw==<br></br>
         </div>
      </div>
      <h5 class="mt-30">Decrypted Response: -</h5>
      <div class="form-box">
         <div class="form-data">
            txn_response:paygate|202104210302|317758778|1.00|IND|INR|2021-10-16|14:42:56.0|1031311634228840037|PG_1031311634228840037|Successful|0|Successful<br></br>
            pg_details:63|Test Bank|NB|<br></br>
            fraud_details:|NA|<br></br>
            other_details:||||<br></br>
         </div>
      </div>
      <h6 class="mt-30"><u>AUTHORIZATIONS:</u></h6>
      <h6 class="mt-10"><span>REQUEST BODY SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/x-www-form-urlencode Not "json"</span></h6>
      <hr class="hr-col" />
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Merchant ID issued to you by Safexpay</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_details"><span class="sc-iemWCZ fhDkLh"></span><span>txn_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Parameter containing Transactions details viz.. order no, Amount, callback url etc..</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_details"><span class="sc-iemWCZ fhDkLh"></span><span>pg_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains bank identifier for on-going transaction.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_details"><span class="sc-iemWCZ fhDkLh"></span><span>cust_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains Customer information required by Acquiring/issuing bank.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_details"><span class="sc-iemWCZ fhDkLh"></span><span>bill_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Billing information of customer transacting.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ship_details"><span class="sc-iemWCZ fhDkLh"></span><span>ship_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Shipping information of customer transacting.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="item_details"><span class="sc-iemWCZ fhDkLh"></span><span>item_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Product details for the on-going transaction.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="card_details"><span class="sc-iemWCZ fhDkLh"></span><span>card_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains Card No, Expiry year, CVV, Card Holder Name.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="other_details"><span class="sc-iemWCZ fhDkLh"></span><span>other_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Additional field to be utilized by merchant for order details.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="upi_details"><span class="sc-iemWCZ fhDkLh"></span><span>upi_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains VPA(Virtual Payment Address) of end customer.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5>Responses</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1" style={{ backgroundColor: "#eff6f0"}}>
            <h5 class="mb-0">
               <div onClick={onClickCangeTab1}>
                  <span className="col-dark-green" style={{ color: "rgb(29, 129, 39)"}}>
                  <b>200</b> Encrypted Response Format {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
                  </span>
               </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <h6 class="mt-30">
               <span>REQUEST BODY SCHEMA:  </span>
               <span className='col-blk'> application/x-www-form-urlencode Not "json"</span>
            </h6>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_response"><span class="sc-iemWCZ fhDkLh"></span><span>txn_response</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains the status of the ongoing transaction with details.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_details"><span class="sc-iemWCZ fhDkLh"></span><span>pg_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains Acquirer and Issuer bank details</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_details"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains transaction risk details.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr class="last undefined">
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="other_details"><span class="sc-iemWCZ fhDkLh"></span><span>other_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Additional parameters for merchant use.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
         }
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>400</b> Bad request</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>401</b> Unauthorized</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>403</b> forbidden</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>404</b> Not found</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>500</b> server_error</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>503</b> service_unavailable</span> </h5>
         </div>
      </div>
      <div class="card mb-60">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div onClick={onClickCangeTab2}>
                  <span>
                     <b>default</b> Succesfull transaction {TabCheck2 ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
                  </span>
               </div>
            </h5>
         </div>
         {
         TabCheck2 &&
         <Accordion/>
         }
      </div>
   </div>
</div>
<div class="col-md-4 extreme-rt-div">
   <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab11}>
               <button> POST </button> /merchantHosted {TabCheck11 ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck11 &&
      <div>
         <br />
         <div class="card-body">
            <p class="mb-0">Production server (uses live data)</p>
            <div class="api-div-bor">
               <span>https://www.avantgardepayments.com/agcore</span><span
                  class="col-org">/merchantHosted</span>
            </div>
            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
            <div class="api-div-bor">
               <span>https://pguat.safexpay.com/agcore</span><span
                  class="col-org">/merchantHosted</span>
            </div>
         </div>
      </div>
      }
   </div>
</div>
<RequestJSON/>
<ResponseJSON/>
</div>
</div>
<hr class="hr-seperator"></hr>
<div class="row">
   <div className='col-md-8'>
      <h2 class="mt-60" id="aggregator-paymode-hosted-sec">Aggregator with Paymode Hosted</h2>
      <p className='mt-30'>The safexpay payment integration provides the feature to show only specific selected pay modes on our Payment page.</p>
      <img class="img-fluid" src="assets/images/pg-images/agg-with-paymode.PNG"></img>
      <h5>Process flow:</h5>
      <ol>
         <li>Merchant can configure the Semi-billing page by showing the Cards / Net banking / Wallets / UPI etc. pay modes on their checkout page.</li>
         <li>Customer selects the respective Paymode options like Cards/NB/UPI etc. on Merchant’s Checkout page.</li>
         <li>Customer redirects to Safexpay Payment page with the selected Paymode options, where customer can fill the relevant detail.</li>
         <li>On submission of the transaction information, Safexpay initiates the authorization process by connecting to the relevant bank/processing organization.</li>
         <li>On receiving the authorization status from the bank, Safexpay sends the response back to your website with the transaction status.</li>
      </ol>
      <div class="rec-box">
         <h6>Recommendation:</h6>
         <p>
            Value in each section will be encrypted value generated in following way. Only me_id (Merchant ID) will be in plain text. Each attribute in every section is combined together separated with pipe (|). Make sure that you are sending the request in HTTP Form post method.<br />
            Transaction request is not compatible to run on Postman Platform. Transactions are only permitted through registered merchant domains. If “localhost” or local IP is not permitted, you will get “Invalid Referral URL.” error in such case. Transaction request must be in below manner when it triggers to our Payment Gateway URL. Merchant must send the following parameters to the Safexpay PG which is mandatory, but values might be blank in case of optional or not required.
         </p>
      </div>
      <h5 className='mt-30'>Example of Transaction request in HTTP Form post method:</h5>
      <div class="form-data">
  
      </div>
      <form name="form1" method="post" action="https://pguat.safexpay.com/agcore/instantPay" target="_blank">
  <input type="hidden" readonly="" name="meId" value="201712050001"/>
  <input type="hidden" readonly="" name="amount" value=""/>
  <input type="hidden" readonly="" name="txnType" value="instantPay"/>
  <input type="hidden" readonly="" name="token" value="07wJ9japKHDt2kLhzP8nsNZMlZAmvSdMmh0a7WHbo*gk3WPxcoS3*XOZ4xVqIA8k"/>
  <input type="hidden" readonly="" name="successUrl" value=""/>
  <input type="hidden" readonly="" name="failureUrl" value=""/>
  <input type="hidden" readonly="" name="custTxnAmount" value="2"/>
  <input type="hidden" readonly="" name="countryCode" value="IND"/>
  <input type="hidden" readonly="" name="currencyCode" value="INR"/>
  <input type="hidden" readonly="" name="custName" value="test test"/>
  <input type="hidden" readonly="" name="emailId" value="u@u.com"/>
  <input type="hidden" readonly="" name="mobileNo" value="8888888888"/>
  <input type="hidden" readonly="" name="billAddress" value="test bill 1"/>
  <input type="hidden" readonly="" name="billCity" value="mumbai"/>
  <input type="hidden" readonly="" name="billState" value="Maharashtra"/>
  <input type="hidden" readonly="" name="billCountry" value=""/>
  <input type="hidden" readonly="" name="billZip" value=""/>
  <input type="hidden" readonly="" name="shipAddress" value=""/>
  <input type="hidden" readonly="" name="shipCity" value=""/>
  <input type="hidden" readonly="" name="shipState" value=""/>
  <input type="hidden" readonly="" name="shipCountry" value=""/>
  <input type="hidden" readonly="" name="shipZip" value=""/>

  <input class="btn btn-success mt-1 mb-1" name="Submit" type="submit" value="Try Checkout"/>
</form>
      <h5 className='mt-30'>Decrypted Request:-</h5>
      <div class="form-data">
      </div>
      <h5 className='mt-30'>Encrypted Response: -</h5>
      <div className='form-box'>
         <div class="form-data">
            txn_response: 9rDkZ+Z6yw7LqxZhDhJOa12+J/pO/A2vYt0WqViUNo9RdijYik8FTx+J7fcDExAJ9+JWc29Z+<br></br>
            pg_details: VYMSdSPAou3KlcdmnNQMcUAp85X4cEO0V48L/cmXWgQ=<br></br>
            fraud_details: ohteK/+vxZqmlXNSdlggZg==<br></br>
            other_details: RpoxJcbt+QsFnWAKjf4LQw==<br></br>
         </div>
      </div>
      <h5 className='mt-30'>Decrypted Response: -</h5>
      <div className='form-box'>
         <div className="form-data">
            txn_response:paygate|202104210302|317758778|1.00|IND|INR|2021-10-16|14:42:56.0|1031311634228840037|PG_1031311634228840037|Successful|0|Successful<br/>
            pg_details:63|Test Bank|NB|<br/>
            fraud_details:|NA|<br/>
            other_details:||||<br/>
         </div>
      </div>
      <h6 class="mt-30"><u>AUTHORIZATIONS:</u></h6>
      <h6 class="mt-10"><span>REQUEST BODY SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/x-www-form-urlencode Not "json"</span></h6>
      <hr class="hr-col" />
      <table class="sc-hHEiqL iZJLLY">
         <tbody>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span class="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Merchant ID issued to you by Safexpay</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_details"><span class="sc-iemWCZ fhDkLh"></span><span>txn_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Parameter containing Transaction details viz.. order no, Amount, callback url etc..</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_details"><span class="sc-iemWCZ fhDkLh"></span><span>pg_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains bank identifier for on-going transaction.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="cust_details"><span class="sc-iemWCZ fhDkLh"></span><span>cust_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains Customer information required by Acquiring/issuing bank.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="bill_details"><span class="sc-iemWCZ fhDkLh"></span><span>bill_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Billing information of customer transacting.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ship_details"><span class="sc-iemWCZ fhDkLh"></span><span>ship_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Shipping information of customer transacting.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="item_details"><span class="sc-iemWCZ fhDkLh"></span><span>item_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Product details for the on-going transaction.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="card_details"><span class="sc-iemWCZ fhDkLh"></span><span>card_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains Card No, Expiry year, CVV, Card Holder Name.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr>
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="other_details"><span class="sc-iemWCZ fhDkLh"></span><span>other_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Additional field to be utilized by merchant for order details.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
            <tr class="last undefined">
               <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="upi_details"><span class="sc-iemWCZ fhDkLh"></span><span>upi_details</span></td>
               <td class="sc-bkbkJK gmOLLi">
                  <div>
                     <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                     <div>
                        <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                           <p>Contains VPA(Virtual Payment Address) of end customer.</p>
                        </div>
                     </div>
                  </div>
               </td>
            </tr>
         </tbody>
      </table>
      <h5>Responses</h5>
      <div class="accordion accordion-alterate arrow-right mt-30" id="popularTopics">
         <div class="card">
            <div class="card-header" id="heading1" style={{ backgroundColor: "#eff6f0"}}>
            <h5 class="mb-0">
               <div  onClick={onClickCangeTab1}>
                  <span className="col-dark-green" style={{ color: "rgb(29, 129, 39)"}}>
                  <b>200</b> Encrypted Response Format {TabCheck1 ?
                  <FaAngleUp />
                  :
                  <FaAngleDown />
                  }
                  </span>
               </div>
            </h5>
         </div>
         {
         TabCheck1 &&
         <div>
            <h6 class="mt-30">
               <span>REQUEST BODY SCHEMA:  </span>
               <span className='col-blk'> application/x-www-form-urlencode Not "json"</span>
            </h6>
            <hr class="hr-col">
            </hr>
            <table class="sc-hHEiqL iZJLLY">
               <tbody>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_response"><span class="sc-iemWCZ fhDkLh"></span><span>txn_response</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains the status of the ongoing transaction with details.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_details"><span class="sc-iemWCZ fhDkLh"></span><span>pg_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains Acquirer and Issuer bank details</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr>
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_details"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Contains transaction risk details.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
                  <tr class="last undefined">
                     <td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="other_details"><span class="sc-iemWCZ fhDkLh"></span><span>other_details</span></td>
                     <td class="sc-bkbkJK gmOLLi">
                        <div>
                           <div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                           <div>
                              <div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                 <p>Additional parameters for merchant use.</p>
                              </div>
                           </div>
                        </div>
                     </td>
                  </tr>
               </tbody>
            </table>
         </div>
         }
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>400</b> Bad request</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>401</b> Unauthorized</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>403</b> forbidden</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>404</b> Not found</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>500</b> server_error</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header">
            <h5 class="mb-0"> <span><b>503</b> service_unavailable</span> </h5>
         </div>
      </div>
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div onClick={onClickCangeTab2}>
                  <span>
                     <b>default</b> Succesfull transaction {TabCheck2 ?
                     <FaAngleUp />
                     :
                     <FaAngleDown />
                     }
                  </span>
               </div>
            </h5>
         </div>
         {
         TabCheck2 &&
         <Accordion/>
         }
      </div>
   </div>
</div>
<div className='col-md-4 extreme-rt-div'>
   <div class="accordion accordion-alterate arrow-right mt-60 side-api" id="popularTopics">
      <div class="card">
         <div class="card-header" id="heading1">
            <h5 class="mb-0">
               <div style={{ backgroundColor: "rgb(17 23 26)", color: "#fff" }} onClick={onClickCangeTab21}>
               <button> POST </button> /aggregatorWithPaymode {TabCheck21 ?
               <FaAngleUp />
               :
               <FaAngleDown />
               }
         </div>
         </h5>
      </div>
      {
      TabCheck21 &&
      <div>
         <br />
         <div class="card-body">
            <p class="mb-0">Production server (uses live data)</p>
            <div class="api-div-bor">
               <span>https://www.avantgardepayments.com/agcore</span><span
                  class="col-org">/aggregatorWithPaymode</span>
            </div>
            <p class="mb-0 mt-20">Sandbox server (uses test data)</p>
            <div class="api-div-bor">
               <span>https://pguat.safexpay.com/agcore</span><span
                  class="col-org">/aggregatorWithPaymode</span>
            </div>
         </div>
      </div>
      }
   </div>
</div>
<RequestJSON/>
<ResponseJSON/>
</div>
</div>
</div>
</div>
)
}
export default PaymentIntegration